export const ChiropractorMetaInfo = {
    "Chiropractor":{
     title:"Chiropractor",
     description:"Connect with a verified chiropractor for personalized care. Expert services to relieve pain and improve overall wellness."
    },
}